"use client";

import { api } from "@klarify/ui/trpc/client";
import { classifyTrafficSource } from "@klarify/utilities";
import { useEffect } from "react";
import { alreadyTrackedRecently, getOrCreateVisitorId } from "./visitor-id";

type Props = {
	clinicId: string;
	clinicSlug: string;
};

export function TrackProfileView({ clinicId, clinicSlug }: Props) {
	const track = api.trackingRouter.trackPublicPageview.useMutation();

	useEffect(() => {
		// 30-min dedup so back-nav and remounts don't inflate counts.
		if (alreadyTrackedRecently(`profile:${clinicId}`)) {
			return;
		}
		const source = classifyTrafficSource(
			document.referrer || undefined,
			window.location.hostname,
		);
		track.mutate({
			distinctId: getOrCreateVisitorId(),
			event: "therapist_profile_viewed",
			properties: { clinicId, clinicSlug, source },
		});
	}, [clinicId, clinicSlug, track]);

	return null;
}
